import React from 'react';
import PropTypes from 'prop-types';
import ContentLoader from 'react-content-loader';

const BubblesSkeleton = ({className, ...props}) => (
  <ContentLoader
    className={className}
    speed={2}
    width={40}
    height={20}
    viewBox="0 0 40 20"
    backgroundColor="#f3f3f3"
    foregroundColor="#ecebeb"
    {...props}
  >
    <circle cx="5" cy="12" r="5" />
    <circle cx="20" cy="12" r="5" />
    <circle cx="35" cy="12" r="5" />
  </ContentLoader>
);

BubblesSkeleton.propTypes = {
  /** Optional classname to add to the skeleton container */
  className: PropTypes.string,
};

export default BubblesSkeleton;
